/* eslint-disable array-callback-return */
import React, { useState, useEffect } from "react";
import axios from "axios";
import dayjs from "dayjs";
import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Typography,
  Modal,
  Form,
  Input,
  InputNumber,
  Select,
  Slider,
  Tag,
  Space,
  Image,
  Badge,
  Statistic,
  Alert,
  Divider,
  notification,
  Avatar,
  Collapse,
  Empty,
  List,
  Descriptions,
} from "antd";
import {
  DeleteTwoTone,
  EditTwoTone,
  InfoCircleOutlined,
  PlusOutlined,
  FilterOutlined,
  FacebookOutlined,
  InstagramOutlined,
  GlobalOutlined,
  SearchOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  CalendarOutlined,
  TagOutlined,
  StarOutlined,
  GiftOutlined,
  TrophyOutlined,
  UserOutlined,
  HeartOutlined,
  MessageOutlined,
  DollarOutlined,
  LinkOutlined,
  CameraOutlined,
  ShoppingCartOutlined,
  PercentageOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  TeamOutlined,
  FireOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import _ from "lodash";
import EtablissementModal from "./Modals/EtablissementModal";

const { Title, Text, Paragraph } = Typography;
const { Option } = Select;
const { Panel } = Collapse;

export const toEuro = (val) => {
  const formatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  });
  return formatter.format(val);
};

// Composant pour afficher une catégorie de récompense
const RewardCategoryCard = ({ category, level }) => {
  const iconMap = {
    service: <ShoppingCartOutlined />,
    produit: <GiftOutlined />,
    réduction: <PercentageOutlined />,
  };

  const colorMap = {
    starter: "green",
    trendy: "orange",
    pro: "purple",
    superStar: "gold",
  };

  return (
    <Card size="small" style={{ marginBottom: 12 }}>
      <Row align="middle" gutter={12}>
        <Col>
          <Avatar
            icon={iconMap[category.category]}
            style={{ backgroundColor: colorMap[level] }}
          />
        </Col>
        <Col flex="auto">
          <div>
            <Text strong>{category.name}</Text>
            <br />
            <Tag color={colorMap[level]} style={{ marginTop: 4 }}>
              {category.category}
            </Tag>
          </div>
        </Col>
        <Col>
          <div style={{ textAlign: "right" }}>
            <Text type="secondary" style={{ fontSize: "12px" }}>
              Valeur: {toEuro(category.value)}
            </Text>
            <br />
            <Text type="secondary" style={{ fontSize: "12px" }}>
              Coût: {toEuro(category.realValue)}
            </Text>
          </div>
        </Col>
      </Row>

      {/* Affichage de la condition spécifique à cette catégorie */}
      {category[`${level}Condition`] && (
        <>
          <Divider style={{ margin: "8px 0" }} />
          <Space size="small">
            <CheckCircleOutlined style={{ color: "#52c41a" }} />
            <Text type="secondary" style={{ fontSize: "12px" }}>
              <strong>{category[`${level}Condition`]}:</strong>{" "}
              {category[`${level}ConditionValue`]}
            </Text>
          </Space>
        </>
      )}
    </Card>
  );
};

const Etablissement = () => {
  // State management
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [detailVisible, setDetailVisible] = useState(false);
  const [filterVisible, setFilterVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [actionType, setActionType] = useState("ADD");
  const [filters, setFilters] = useState({
    rating: null,
    priceRange: [10, 50],
    city: null,
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [etablissementDetails, setEtablissementDetails] = useState(null);
  const user = JSON.parse(localStorage.getItem("user"));

  const fetchData = async () => {
    try {
      const response = await axios.get(
        "https://trend-me.com/api/Etablissement"
      );
      const sortedData = _.sortBy(response.data, (o) => Number(o.id));
      setData(sortedData);
      setFilteredData(sortedData);
    } catch (error) {
      notification.error({
        message: "Error fetching data",
        description: error.message,
      });
    }
  };

  const fetchDataByEtab = async () => {
    try {
      const response = await axios.get(
        "https://trend-me.com/api/Etablissement/" + user?.IdEtab
      );
      const sortedData = _.sortBy(response.data, (o) => Number(o.id));
      setData(sortedData);
      setFilteredData(sortedData);
      // Pour l'établissement connecté, on récupère directement les détails
      if (sortedData.length > 0) {
        setEtablissementDetails(sortedData[0]);
      }
    } catch (error) {
      notification.error({
        message: "Error fetching data",
        description: error.message,
      });
    }
  };

  // Data fetching
  useEffect(() => {
    if (user?.type === "admin") {
      fetchData();
    } else {
      fetchDataByEtab();
    }
  }, []);

  // Si c'est un établissement connecté, afficher la vue détaillée
  if (user?.type !== "admin" && etablissementDetails) {
    return (
      <div
        style={{ padding: "24px", background: "#f5f5f5", minHeight: "100vh" }}
      >
        <Card style={{ maxWidth: "1200px", margin: "0 auto" }}>
          {/* Section 1: Informations principales */}
          <Row align="middle" gutter={24} style={{ marginBottom: "32px" }}>
            <Col>
              <Avatar
                size={120}
                src={`https://trend-me.com/upload/${etablissementDetails.avatar}`}
                style={{ border: "4px solid #f0f0f0" }}
              />
            </Col>
            <Col flex="auto">
              <Title level={1} style={{ marginBottom: "8px" }}>
                {etablissementDetails.name}
              </Title>
              <Space direction="vertical" size="small">
                <Space>
                  <InstagramOutlined style={{ color: "#E4405F" }} />
                  <Text strong>{etablissementDetails.cardDescription}</Text>
                </Space>
                <Space>
                  <EnvironmentOutlined style={{ color: "#52c41a" }} />
                  <Text>{etablissementDetails.location}</Text>
                </Space>
                <Space>
                  <PhoneOutlined style={{ color: "#1890ff" }} />
                  <Text>{etablissementDetails.phone}</Text>
                </Space>
              </Space>
            </Col>
          </Row>

          <Divider />

          {/* Section 2: Description */}
          <div style={{ marginBottom: "32px" }}>
            <Title level={3}>
              <InfoCircleOutlined /> Description de l'établissement
            </Title>
            <Card bordered={false} style={{ background: "#fafafa" }}>
              <Paragraph
                style={{
                  fontSize: "16px",
                  lineHeight: "1.8",
                  whiteSpace: "pre-line",
                }}
              >
                {etablissementDetails.description}
              </Paragraph>
            </Card>
          </div>

          <Divider />

          {/* Section 3: Galerie photos */}
          <div style={{ marginBottom: "32px" }}>
            <Title level={3}>
              <CameraOutlined /> Galerie photos
            </Title>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
              <Image
                src={`https://trend-me.com/upload/${etablissementDetails.avatar}`}
                width={200}
                height={200}
                style={{ objectFit: "cover", borderRadius: "8px" }}
              />
              {etablissementDetails.couverture && (
                <Image
                  src={`https://trend-me.com/upload/${etablissementDetails.couverture}`}
                  width={200}
                  height={200}
                  style={{ objectFit: "cover", borderRadius: "8px" }}
                />
              )}
              {etablissementDetails.multimedia?.map((media, index) => (
                <Image
                  key={index}
                  src={media.url}
                  width={200}
                  height={200}
                  style={{ objectFit: "cover", borderRadius: "8px" }}
                />
              ))}
            </div>
          </div>

          <Divider />

          {/* Section 4: Campagne Active */}
          {etablissementDetails.campagnes &&
            etablissementDetails.campagnes.length > 0 && (
              <div style={{ marginBottom: "32px" }}>
                <Title level={3}>
                  <FireOutlined /> Campagne Active
                </Title>
                <Card>
                  <Row gutter={16}>
                    <Col span={8}>
                      <Statistic
                        title="Nom de la campagne"
                        value={etablissementDetails.campagnes[0].name}
                        prefix={<TagOutlined />}
                      />
                    </Col>
                    <Col span={8}>
                      <Statistic
                        title="Type"
                        value={etablissementDetails.campagnes[0].type}
                        prefix={<InstagramOutlined />}
                      />
                    </Col>
                    <Col span={8}>
                      <Statistic
                        title="Budget"
                        value={toEuro(etablissementDetails.campagnes[0].budget)}
                        prefix={<DollarOutlined />}
                      />
                    </Col>
                  </Row>

                  <Divider />

                  <Row gutter={16}>
                    <Col span={12}>
                      <Space>
                        <CalendarOutlined />
                        <Text strong>Période: </Text>
                        <Text>
                          {dayjs(
                            etablissementDetails.campagnes[0].dateDebut
                          ).format("DD/MM/YYYY")}{" "}
                          -{" "}
                          {dayjs(
                            etablissementDetails.campagnes[0].dateFin
                          ).format("DD/MM/YYYY")}
                        </Text>
                      </Space>
                    </Col>
                    <Col span={12}>
                      <Space>
                        <TagOutlined />
                        <Text strong>Hashtags: </Text>
                        <div>
                          {etablissementDetails.campagnes[0].mentionsHashTags
                            ?.split(",")
                            .map((tag, index) => (
                              <Tag
                                key={index}
                                color="blue"
                                style={{ margin: "2px" }}
                              >
                                {tag.trim()}
                              </Tag>
                            ))}
                        </div>
                      </Space>
                    </Col>
                  </Row>
                </Card>
              </div>
            )}

          <Divider />

          {/* Section 5: Système de Scoring */}
          <div style={{ marginBottom: "32px" }}>
            <Title level={3}>
              <TrophyOutlined /> Système de Scoring
            </Title>
            <Row gutter={16}>
              <Col span={8}>
                <Card>
                  <Statistic
                    title="Points par Like"
                    value={
                      etablissementDetails.campagnes?.[0]?.scoring?.like ||
                      "Non défini"
                    }
                    prefix={<HeartOutlined style={{ color: "#ff4d4f" }} />}
                    suffix="pts"
                  />
                </Card>
              </Col>
              <Col span={8}>
                <Card>
                  <Statistic
                    title="Points par Commentaire"
                    value={
                      etablissementDetails.campagnes?.[0]?.scoring?.comment ||
                      "Non défini"
                    }
                    prefix={<MessageOutlined style={{ color: "#52c41a" }} />}
                    suffix="pts"
                  />
                </Card>
              </Col>
              <Col span={8}>
                <Card>
                  <Statistic
                    title="Points par Follower"
                    value={
                      etablissementDetails.campagnes?.[0]?.scoring?.followers ||
                      "Non défini"
                    }
                    prefix={<UserOutlined style={{ color: "#1890ff" }} />}
                    suffix="pts"
                  />
                </Card>
              </Col>
            </Row>
          </div>

          <Divider />

          {/* Section 6: Critères de Participation */}
          <div style={{ marginBottom: "32px" }}>
            <Title level={3}>
              <CheckCircleOutlined /> Critères de Participation
            </Title>
            <Card>
              <Row gutter={16}>
                <Col span={12}>
                  <Card size="small">
                    <Statistic
                      title="Followers minimum requis"
                      value={
                        etablissementDetails.campagnes?.[0]?.nbfollowersMin ||
                        "Non défini"
                      }
                      prefix={<TeamOutlined />}
                    />
                  </Card>
                </Col>
                <Col span={12}>
                  <Card size="small">
                    <Statistic
                      title="Durée minimum (heures)"
                      value={
                        etablissementDetails.campagnes?.[0]?.nbhoursMin ||
                        "Non défini"
                      }
                      prefix={<ClockCircleOutlined />}
                      suffix="h"
                    />
                  </Card>
                </Col>
              </Row>

              <Divider />

              <Card size="small" style={{ background: "#f9f9f9" }}>
                <Row gutter={16}>
                  <Col span={8}>
                    <Text strong>Participations par utilisateur: </Text>
                    <Text>
                      {
                        etablissementDetails.campagnes?.[0]?.recompenseOption
                          ?.participationPerUser
                      }{" "}
                      fois
                    </Text>
                  </Col>
                  <Col span={8}>
                    <Text strong>Défi à relever: </Text>
                    <Text>
                      {
                        etablissementDetails.campagnes?.[0]?.recompenseOption
                          ?.challengeDescription
                      }
                    </Text>
                  </Col>
                  <Col span={8}>
                    <Text strong>Type de prix utilisé: </Text>
                    <Text>
                      {etablissementDetails.campagnes?.[0]?.recompenseOption
                        ?.useRealOrPurchasePrice === "real"
                        ? "Prix d'achat (coût réel)"
                        : "Prix de vente (valeur perçue)"}
                    </Text>
                  </Col>
                </Row>

                <Divider />

                <Row gutter={16}>
                  <Col span={12}>
                    <Text strong>Délai de validation: </Text>
                    <Text>
                      {
                        etablissementDetails.campagnes?.[0]?.recompenseOption
                          ?.nbOfDaystoBeValdiated
                      }{" "}
                      jours
                    </Text>
                  </Col>
                  <Col span={12}>
                    <Text strong>Durée de validité: </Text>
                    <Text>
                      {
                        etablissementDetails.campagnes?.[0]?.recompenseOption
                          ?.nbOfDaysforAvailability
                      }{" "}
                      jours
                    </Text>
                  </Col>
                </Row>
              </Card>
            </Card>
          </div>

          <Divider />

          {/* Section 7: Système de Récompenses Détaillé */}
          <div style={{ marginBottom: "32px" }}>
            <Title level={3}>
              <GiftOutlined /> Système de Récompenses
            </Title>

            <Collapse ghost>
              {/* Niveau Starter */}
              <Panel
                header={
                  <Row align="middle" gutter={12}>
                    <Col>
                      <Avatar
                        icon={<StarOutlined />}
                        style={{ backgroundColor: "#52c41a" }}
                      />
                    </Col>
                    <Col>
                      <Space direction="vertical" size={0}>
                        <Text strong style={{ fontSize: "16px" }}>
                          Niveau Starter
                        </Text>
                        <Text type="secondary">
                          {
                            etablissementDetails.campagnes?.[0]
                              ?.recompenseOption?.starterPoints
                          }{" "}
                          points requis
                        </Text>
                      </Space>
                    </Col>
                  </Row>
                }
                key="starter"
              >
                <Card>
                  <Row gutter={16}>
                    <Col span={12}>
                      <Title level={4}>
                        {
                          etablissementDetails.campagnes?.[0]?.recompenseOption
                            ?.starterTitle
                        }
                      </Title>
                      <Space direction="vertical" size="small">
                        <Space>
                          <GiftOutlined />
                          <Text strong>Valeur perçue: </Text>
                          <Text>
                            {toEuro(
                              etablissementDetails.campagnes?.[0]
                                ?.recompenseOption?.starterValue
                            )}
                          </Text>
                        </Space>
                        <Space>
                          <DollarOutlined />
                          <Text strong>Coût réel: </Text>
                          <Text>
                            {toEuro(
                              etablissementDetails.campagnes?.[0]
                                ?.recompenseOption?.starterRealValue
                            )}
                          </Text>
                        </Space>
                      </Space>
                    </Col>
                    <Col span={12}>
                      <Title level={5}>Catégories de récompenses</Title>
                      {etablissementDetails.campagnes?.[0]?.recompenseOption?.starterCategory?.map(
                        (category, index) => (
                          <RewardCategoryCard
                            key={index}
                            category={category}
                            level="starter"
                          />
                        )
                      )}
                    </Col>
                  </Row>
                </Card>
              </Panel>

              {/* Niveau Trendy */}
              <Panel
                header={
                  <Row align="middle" gutter={12}>
                    <Col>
                      <Avatar
                        icon={<TrophyOutlined />}
                        style={{ backgroundColor: "#faad14" }}
                      />
                    </Col>
                    <Col>
                      <Space direction="vertical" size={0}>
                        <Text strong style={{ fontSize: "16px" }}>
                          Niveau Trendy
                        </Text>
                        <Text type="secondary">
                          {
                            etablissementDetails.campagnes?.[0]
                              ?.recompenseOption?.trendyPoints
                          }{" "}
                          points requis
                        </Text>
                      </Space>
                    </Col>
                  </Row>
                }
                key="trendy"
              >
                <Card>
                  <Row gutter={16}>
                    <Col span={12}>
                      <Title level={4}>
                        {
                          etablissementDetails.campagnes?.[0]?.recompenseOption
                            ?.trendyTitle
                        }
                      </Title>
                      <Space direction="vertical" size="small">
                        <Space>
                          <GiftOutlined />
                          <Text strong>Valeur perçue: </Text>
                          <Text>
                            {toEuro(
                              etablissementDetails.campagnes?.[0]
                                ?.recompenseOption?.trendyValue
                            )}
                          </Text>
                        </Space>
                        <Space>
                          <DollarOutlined />
                          <Text strong>Coût réel: </Text>
                          <Text>
                            {toEuro(
                              etablissementDetails.campagnes?.[0]
                                ?.recompenseOption?.trendyRealValue
                            )}
                          </Text>
                        </Space>
                      </Space>
                    </Col>
                    <Col span={12}>
                      <Title level={5}>Catégories de récompenses</Title>
                      {etablissementDetails.campagnes?.[0]?.recompenseOption?.trendyCategory?.map(
                        (category, index) => (
                          <RewardCategoryCard
                            key={index}
                            category={category}
                            level="trendy"
                          />
                        )
                      )}
                    </Col>
                  </Row>
                </Card>
              </Panel>

              {/* Niveau Pro */}
              <Panel
                header={
                  <Row align="middle" gutter={12}>
                    <Col>
                      <Avatar
                        icon={<StarOutlined />}
                        style={{ backgroundColor: "#722ed1" }}
                      />
                    </Col>
                    <Col>
                      <Space direction="vertical" size={0}>
                        <Text strong style={{ fontSize: "16px" }}>
                          Niveau Pro
                        </Text>
                        <Text type="secondary">
                          {
                            etablissementDetails.campagnes?.[0]
                              ?.recompenseOption?.proPoints
                          }{" "}
                          points requis
                        </Text>
                      </Space>
                    </Col>
                  </Row>
                }
                key="pro"
              >
                <Card>
                  <Row gutter={16}>
                    <Col span={12}>
                      <Title level={4}>
                        {
                          etablissementDetails.campagnes?.[0]?.recompenseOption
                            ?.proTitle
                        }
                      </Title>
                      <Space direction="vertical" size="small">
                        <Space>
                          <GiftOutlined />
                          <Text strong>Valeur perçue: </Text>
                          <Text>
                            {toEuro(
                              etablissementDetails.campagnes?.[0]
                                ?.recompenseOption?.proValue
                            )}
                          </Text>
                        </Space>
                        <Space>
                          <DollarOutlined />
                          <Text strong>Coût réel: </Text>
                          <Text>
                            {toEuro(
                              etablissementDetails.campagnes?.[0]
                                ?.recompenseOption?.proRealValue
                            )}
                          </Text>
                        </Space>
                      </Space>
                    </Col>
                    <Col span={12}>
                      <Title level={5}>Catégories de récompenses</Title>
                      {etablissementDetails.campagnes?.[0]?.recompenseOption?.proCategory?.map(
                        (category, index) => (
                          <RewardCategoryCard
                            key={index}
                            category={category}
                            level="pro"
                          />
                        )
                      )}
                    </Col>
                  </Row>
                </Card>
              </Panel>

              {/* Niveau Super Star */}
              <Panel
                header={
                  <Row align="middle" gutter={12}>
                    <Col>
                      <Avatar
                        icon={<StarOutlined />}
                        style={{ backgroundColor: "#fadb14" }}
                      />
                    </Col>
                    <Col>
                      <Space direction="vertical" size={0}>
                        <Text strong style={{ fontSize: "16px" }}>
                          Niveau Super Star
                        </Text>
                        <Text type="secondary">
                          {
                            etablissementDetails.campagnes?.[0]
                              ?.recompenseOption?.superStarPoints
                          }{" "}
                          points requis
                        </Text>
                      </Space>
                    </Col>
                  </Row>
                }
                key="superStar"
              >
                <Card>
                  <Row gutter={16}>
                    <Col span={12}>
                      <Title level={4}>
                        {
                          etablissementDetails.campagnes?.[0]?.recompenseOption
                            ?.superStarTitle
                        }
                      </Title>
                      <Space direction="vertical" size="small">
                        <Space>
                          <GiftOutlined />
                          <Text strong>Valeur perçue: </Text>
                          <Text>
                            {toEuro(
                              etablissementDetails.campagnes?.[0]
                                ?.recompenseOption?.superStarValue
                            )}
                          </Text>
                        </Space>
                        <Space>
                          <DollarOutlined />
                          <Text strong>Coût réel: </Text>
                          <Text>
                            {toEuro(
                              etablissementDetails.campagnes?.[0]
                                ?.recompenseOption?.superStarRealValue
                            )}
                          </Text>
                        </Space>
                      </Space>
                    </Col>
                    <Col span={12}>
                      <Title level={5}>Catégories de récompenses</Title>
                      {etablissementDetails.campagnes?.[0]?.recompenseOption?.superStarCategory?.map(
                        (category, index) => (
                          <RewardCategoryCard
                            key={index}
                            category={category}
                            level="superStar"
                          />
                        )
                      )}
                    </Col>
                  </Row>
                </Card>
              </Panel>
            </Collapse>
          </div>

          {/* Section 8: Récompense Immédiate */}
          {etablissementDetails.campagnes?.[0]?.recomponseImmediate ===
            "true" && (
            <div style={{ marginBottom: "32px" }}>
              <Divider />
              <Title level={3}>
                <FireOutlined /> Récompense Immédiate
              </Title>
              <Alert
                message="Récompense immédiate activée!"
                type="success"
                showIcon
                style={{ marginBottom: 16 }}
              />
              <Card>
                <Row gutter={16}>
                  <Col span={8}>
                    <Statistic
                      title="Valeur de la récompense"
                      value={toEuro(
                        etablissementDetails.campagnes?.[0]
                          ?.recomponseImmediateValue
                      )}
                      prefix={<GiftOutlined />}
                    />
                  </Col>
                  <Col span={8}>
                    <Statistic
                      title="Coût réel"
                      value={toEuro(
                        etablissementDetails.campagnes?.[0]
                          ?.recomponseImmediateRealValue
                      )}
                      prefix={<DollarOutlined />}
                    />
                  </Col>
                  <Col span={8}>
                    <Statistic
                      title="Disponibilité"
                      value={
                        etablissementDetails.campagnes?.[0]
                          ?.recomponseImmediatenbOfDaysforAvailability === "1"
                          ? "Immédiate"
                          : `${etablissementDetails.campagnes?.[0]?.recomponseImmediatenbOfDaysforAvailability} jours`
                      }
                      prefix={<ClockCircleOutlined />}
                    />
                  </Col>
                </Row>
              </Card>
            </div>
          )}

          <Divider />

          {/* Section 9: Réseaux Sociaux */}
          <div style={{ marginBottom: "32px" }}>
            <Title level={3}>
              <LinkOutlined /> Présence sur les réseaux sociaux
            </Title>
            <Row gutter={16}>
              {etablissementDetails.solialMedia?.map((social, index) => (
                <Col key={index} span={8}>
                  <Card>
                    <Space>
                      {social.type === "instagram" && (
                        <InstagramOutlined
                          style={{ color: "#E4405F", fontSize: "24px" }}
                        />
                      )}
                      {social.type === "facebook" && (
                        <FacebookOutlined
                          style={{ color: "#1877F2", fontSize: "24px" }}
                        />
                      )}
                      {social.type === "GoogleMaps" && (
                        <GlobalOutlined
                          style={{ color: "#34A853", fontSize: "24px" }}
                        />
                      )}
                      <div>
                        <Text strong>
                          {social.type.charAt(0).toUpperCase() +
                            social.type.slice(1)}
                        </Text>
                        <div>
                          <a
                            href={social.link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <LinkOutlined /> Voir le profil
                          </a>
                        </div>
                      </div>
                    </Space>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        </Card>
      </div>
    );
  }

  // Code pour admin (reste inchangé)
  const handleDelete = async (id) => {
    Modal.confirm({
      title: "Confirmer la suppression",
      content: "Êtes-vous sûr de vouloir supprimer cet établissement ?",
      okText: "Oui",
      cancelText: "Non",
      onOk: async () => {
        try {
          await axios.delete(`https://trend-me.com/api/Etablissement/${id}`);
          notification.success({
            message: "Succès",
            description: "Établissement supprimé avec succès",
          });
          fetchData();
        } catch (error) {
          notification.error({
            message: "Erreur",
            description: "Échec de la suppression de l'établissement",
          });
        }
      },
    });
  };

  // Table columns with full DTO integration
  const columns = [
    {
      title: "Avatar",
      render: (_, record) => (
        <Image
          src={`https://trend-me.com/upload/${record.avatar}`}
          width={80}
          preview={false}
          fallback="https://via.placeholder.com/80"
        />
      ),
    },
    {
      title: "Nom",
      dataIndex: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },

    {
      title: "Localisation",
      render: (_, record) => (
        <div>
          <div>{record.ville}</div>
          <Text type="secondary">{record.codePostal}</Text>
          <div>{record.adresse}</div>
        </div>
      ),
    },
    {
      title: "Téléphone",
      render: (_, record) => <div>{record.phone || "Non renseigné"}</div>,
    },
    {
      title: "Description",
      render: (_, record) => <div>{record.description}</div>,
    },
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          <Button onClick={() => handleEdit(record)}>
            <EditTwoTone />
          </Button>

          <Button danger onClick={() => handleDelete(record._id)}>
            <DeleteTwoTone twoToneColor="#ff4d4f" />
          </Button>
        </Space>
      ),
    },
  ];

  // Handler functions
  const handleEdit = (record) => {
    setSelectedRecord(record);
    setActionType("EDIT");
    setModalVisible(true);
  };

  // Filter implementation
  const applyFilters = () => {
    let filtered = [...data];

    if (filters.rating) {
      filtered = filtered.filter(
        (item) => parseFloat(item.rating) >= parseFloat(filters.rating)
      );
    }

    if (filters.priceRange) {
      filtered = filtered.filter(
        (item) =>
          item.minPrice >= filters.priceRange[0] &&
          item.maxPrice <= filters.priceRange[1]
      );
    }

    if (filters.city) {
      filtered = filtered.filter((item) =>
        item.ville.toLowerCase().includes(filters.city.toLowerCase())
      );
    }

    setFilteredData(filtered);
    setFilterVisible(false);
  };

  // Search implementation
  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    const filtered = data.filter(
      (item) =>
        item.name.toLowerCase().includes(query) ||
        item.ville.toLowerCase().includes(query) ||
        item.description.toLowerCase().includes(query)
    );

    setFilteredData(filtered);
  };

  return (
    <div className="tabled">
      <Card
        title="Gestion des Établissements"
        extra={
          <Space>
            <Input
              placeholder="Rechercher des établissements..."
              suffix={<SearchOutlined />}
              onChange={handleSearch}
              style={{ width: 250 }}
            />
            <Button
              icon={<FilterOutlined />}
              onClick={() => setFilterVisible(true)}
            >
              Filtres
            </Button>

            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                setSelectedRecord(null);
                setActionType("AJOUT");
                setModalVisible(true);
              }}
            >
              Nouvel Établissement
            </Button>
          </Space>
        }
      >
        <Table
          columns={columns}
          dataSource={filteredData}
          rowKey="id"
          pagination={{ pageSize: 8 }}
          scroll={{ x: 1300 }}
        />
      </Card>

      {/* Modale des filtres */}
      <Modal
        title="Filtres Avancés"
        visible={filterVisible}
        onCancel={() => setFilterVisible(false)}
        footer={[
          <Button
            key="reset"
            onClick={() =>
              setFilters({ note: null, fourchettePrix: [10, 50], ville: null })
            }
          >
            Réinitialiser
          </Button>,
          <Button key="apply" type="primary" onClick={applyFilters}>
            Appliquer
          </Button>,
        ]}
      >
        <Form layout="vertical">
          <Form.Item label="Note minimale">
            <Select
              value={filters.note}
              onChange={(value) => setFilters({ ...filters, note: value })}
              allowClear
            >
              {[5, 4.5, 4, 3.5, 3, 2.5, 2, 1.5, 1].map((num) => (
                <Option key={num} value={num}>
                  {num} ★
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Fourchette de prix (€)">
            <Slider
              range
              min={0}
              max={500}
              value={filters.fourchettePrix}
              onChange={(value) =>
                setFilters({ ...filters, fourchettePrix: value })
              }
              tipFormatter={(value) => `€${value}`}
            />
          </Form.Item>

          <Form.Item label="Ville">
            <Select
              value={filters.ville}
              onChange={(value) => setFilters({ ...filters, ville: value })}
              allowClear
            >
              {["Paris", "Lyon", "Marseille", "Toulouse"].map((ville) => (
                <Option key={ville} value={ville}>
                  {ville}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>

      <EtablissementModal
        visible={modalVisible}
        record={selectedRecord}
        actionType={actionType}
        onCancel={() => {
          setModalVisible(false);
          setSelectedRecord(null);
        }}
        onRefresh={() => {
          fetchData();
        }}
      />
    </div>
  );
};

export default Etablissement;
